import { l } from '../../../lib/imports'
import { createId } from '../../../main/common'
import { voyageMessageBuyRequest } from '../multi/voyageMessageBuyRequest-sidecar'
import { EVoyageCrewCreateMethod } from '../multi/voyageMessageCrewCreate'
import { voyageMessageCrewCreate } from '../multi/voyageMessageCrewCreate-sidecar'
import { EVoyageCarryableType } from '../voyageCarryableData'
import { EVoyageCrewType } from '../voyageCrew'
import { voyageGameStatus } from '../voyageGameStatus-sidecar'
import { voyageTilemap } from '../voyageTilemap-sidecar'
import { EBuyType } from '../voyageUiBuyStuff_data'
import { voyageWebsockets } from '../voyageWebsockets-sidecar'

export function* generator_mission_test(): Generator<number, number, number> {
  if (!voyageWebsockets.getIsHost()) {
    return 0
  }

  voyageGameStatus.get().addJumpCharge = 500

  testItems()
  // testAliens()

  return 0
}

function testItems() {
  let items = [
    EVoyageCarryableType.BattleRifle,
    EVoyageCarryableType.Coffee,
    EVoyageCarryableType.Extinguisher,
    EVoyageCarryableType.Medpack,
    EVoyageCarryableType.Mop,
    EVoyageCarryableType.Torpedo,
    EVoyageCarryableType.Wrench,
    EVoyageCarryableType.AlienCorpse,
  ]
  l.forEach(items, (c) => {
    voyageMessageBuyRequest.sendMessageRequest({
      buyType: EBuyType.item,
      cost: 0,
      crewId: 0,
      itemType: c,
    })
  })
}

function testAliens() {
  for (let i = 0; i < 5; i++) {
    let tp = voyageTilemap.getRandomFloor()
    voyageMessageCrewCreate.sendMessageAndImmediatelyExecute({
      crewId: createId(),
      team: 1,
      energy: 100,
      method: EVoyageCrewCreateMethod.Normal,
      type: EVoyageCrewType.Alien,
      i: tp.i,
      j: tp.j,
    })
  }
}
